export const breadCrumbs = {
  mypage: {
    en: 'My page',
    nb: 'Min side',
    nn: 'Min side',
  },
} as const;
